const WORKSPACE_MEMBERS_KEY_BASE = 'workspace_members';
const WORKSPACE_MEMBERS_KEY_WITH_GROUPS = 'withGroups';
export const WorkspaceMembersKeyFactory = {
    all: () => [WORKSPACE_MEMBERS_KEY_BASE],
    allByWorkspace: (workspaceId) => [
        ...WorkspaceMembersKeyFactory.all(),
        workspaceId,
    ],
    byWorkspace: (workspaceId, withGroups) => [
        ...WorkspaceMembersKeyFactory.allByWorkspace(workspaceId),
        WORKSPACE_MEMBERS_KEY_WITH_GROUPS,
        withGroups,
    ],
};
